import React from 'react';
import Icon from '../../../components/AppIcon';

interface RoleSelectorProps {
  selectedRole: string;
  onRoleSelect: (role: 'brand' | 'creator' | 'agency' | 'admin') => void;
  error?: string;
}

const RoleSelector: React.FC<RoleSelectorProps> = ({ selectedRole, onRoleSelect, error }) => {
  const roles = [
  {
    id: 'brand' as const,
    title: 'Brand',
    description: 'Find and collaborate with top creators',
    icon: 'Building2' as const
  },
  {
    id: 'creator' as const,
    title: 'Creator',
    description: 'Get discovered and work with brands',
    icon: 'Video' as const
  },
  {
    id: 'agency' as const,
    title: 'Agency',
    description: 'Manage multiple brands and creators',
    icon: 'Users' as const
  }];


  return (
    <div className="space-y-4">
      <div className="text-center mb-6">
        <h2 className="text-xl font-bold mb-2 text-[rgba(255,61,61,1)]">Choose Your Role</h2>
        <p className="text-sm text-neutral-100">Select how you want to use NOONX</p>
      </div>

      <div className="grid gap-3">
        {roles.map((role) =>
        <button
          key={role.id}
          type="button"
          onClick={() => onRoleSelect(role.id)}
          className={`
              group relative p-5 rounded-xl border-2 transition-all text-left
              hover:shadow-lg hover:scale-[1.02] active:scale-[0.98]
              ${
          selectedRole === role.id ?
          'border-[#E42313] bg-red-50 shadow-lg' :
          'border-gray-200 bg-white hover:border-gray-300'}
            `
          }>

            <div className="flex items-start space-x-4">
              <div
              className={`
                  flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center transition-all
                  ${
              selectedRole === role.id ?
              'bg-[#E42313] text-white' :
              'bg-gray-100 text-gray-600 group-hover:bg-gray-200'}
                `
              }>

                <Icon name={role.icon} size={24} />
              </div>
              <div className="flex-1 min-w-0">
                <h3
                className={`
                    text-base font-bold mb-1 transition-colors
                    ${selectedRole === role.id ? 'text-[#E42313]' : 'text-black'}
                  `}>

                  {role.title}
                </h3>
                <p className="text-sm text-gray-600 leading-tight">{role.description}</p>
              </div>
              {selectedRole === role.id &&
            <div className="flex-shrink-0 ml-2">
                  <div className="w-6 h-6 bg-[#E42313] rounded-full flex items-center justify-center">
                    <Icon name="Check" size={16} className="text-white" />
                  </div>
                </div>
            }
            </div>
          </button>
        )}
      </div>

      {error &&
      <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-xl">
          <div className="flex items-center space-x-2">
            <Icon name="AlertCircle" size={18} className="text-[#E42313]" />
            <p className="text-sm font-medium text-[#E42313]">{error}</p>
          </div>
        </div>
      }
    </div>);

};

export default RoleSelector;